// The message BMA sent with a rejected write, when it sent one.
//
// A refusal the backend words itself - a search name that collides with a
// standing bucket's, a rename of a bucket it owns - is the only text that tells
// the operator what to do about it. Axios turns the response into "Request
// failed with status code 409", so reading `err.message` shows them the status
// and nothing else. Shared because the leads surfaces that write kept
// re-deriving the same cast, and a surface that forgot it silently degraded to
// the status line.
export const apiErrorDetail = (err: unknown): string | null =>
  (err as { response?: { data?: { error?: string } } })?.response?.data
    ?.error ?? null;

export const apiErrorStatus = (err: unknown): number | null =>
  (err as { response?: { status?: number } })?.response?.status ?? null;

// What to show the operator: the backend's own words first, then whatever the
// thrown error carried, then the caller's wording for a failure with neither.
export const apiErrorMessage = (err: unknown, fallback: string): string =>
  apiErrorDetail(err) ?? (err instanceof Error ? err.message : fallback);
